module.exports = __webpack_public_path__ + "static/media/plus-icon.95f7ab30.svg";